import React from 'react';
import createForm from "../Form";
import ComponentField from "../../../form/ComponentField";
import DateTimeInput from "../../../form/DateTimeInput";
import CheckBox from "../../../form/CheckBox";
import Select from "../../../form/Select";

class LoyaltyPointDiscountLimitForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-10">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("type")}
                            optionname="LoyaltyPointDiscountLimitType"
                            storeType="local"
                            objectValue={false}
                            name="type"
                            value={this.props.values.type}
                            label="Típus"
                            saveChanges={this.props.setFieldValue}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Select
                            {...this.props.getFieldProps("target_component")}
                            optionname="LoyaltyPointDiscountComponent"
                            storeType="local"
                            objectValue={false}
                            name="target_component"
                            value={this.props.values.target_component}
                            label="Célkomponens"
                            saveChanges={this.props.setFieldValue}
                            required={true}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("limit_value_type")}
                            optionname="LoyaltyPointDiscountRuleCalculationType"
                            storeType="local"
                            objectValue={false}
                            name="limit_value_type"
                            value={this.props.values.limit_value_type}
                            label="Értéktípus"
                            saveChanges={this.props.setFieldValue}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="limit_value"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Érték"
                            required={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        {
                            this.props.values.target_component &&
                            this.props.values.limit_value_type == "percentage" &&
                            <Select
                                {...this.props.getFieldProps("limit_value_target_field")}
                                optionname="LoyaltyPointDiscountComponentField"
                                filter={[
                                    {
                                        field: "xtradata",
                                        operator: "like",
                                        value: this.props.values.target_component
                                    }
                                ]}
                                storeType="local"
                                objectValue={false}
                                name="limit_value_target_field"
                                value={this.props.values.limit_value_target_field}
                                label="Értékszámolás alapja"
                                saveChanges={this.props.setFieldValue}
                                required={true}
                            />
                        }
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(LoyaltyPointDiscountLimitForm);
